import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState: any = {
  token: "",
  userInfo: {},
};

export const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    setToken: (state, actions) => {
      const { token } = actions.payload;
      state.token = token;
    },
    setUserInfo: (state, actions: PayloadAction<any>) => {
      state.userInfo = actions.payload;
    },
    logout: (state) => {
      state.token = "";
      state.userInfo = {};
    },
  },
});
